import { returnUniqueStrings } from "utils/builder/IScheduleLogic";
export const getTranslations = (locale) => (state) => state.translations[locale];

export const getAllPossibleExpressions = (state) => {
    // return all possible expression that need to be translated in case the user turn on 'isTranslateModelEnabled'.
    const viewer = state.viewer

    if (!state) {
        return []
    }
    
    const allPossibleExpressions = [
        viewer.categories,
        viewer.properties,
        viewer.templateSetting?.categories,
        viewer.templateSetting?.categories,
        viewer.commonProperties
    ]

    const collections = viewer.collections
    if (collections && collections.length) {
        collections.forEach(collection => {
            allPossibleExpressions.push(collection.properties)
            allPossibleExpressions.push(collection.groupBy)
        });
    }

    return returnUniqueStrings(allPossibleExpressions)
}